// extracted by mini-css-extract-plugin
export var cardIcon = "_7c-4";
export var checkboxCard = "_7c-0";
export var checkboxCardSelected = "_7c-3";
export var disabled = "_7c-1";
export var outerBorder = "_7c-2";
export var spacerMedium = "_7c-7";
export var spacerSmall = "_7c-6";
export var spacerXsmall = "_7c-5";